const uikitLoaded = {}
export async function loadUIkitComponent(name) {
  if (uikitLoaded[name]) {
    return uikitLoaded[name]
  }
  const promises: Promise<unknown>[] = []
  switch (name) {
    case '@uikit/vue-member':
      promises.push(import('kFederationComponent/member'))
      break
    case '@uikit/vue-finder':
      promises.push(import('kFederationComponent/finder'))
      break
    case '@uikit/member-card':
      promises.push(import('kFederationComponent/member-card'))
      break
    default:
      throw new Error(`找不到组件${name}`)
  }
  const [component] = await Promise.all(promises)
  uikitLoaded[name] = component
  return component
}
